module.exports = __webpack_public_path__ + "assets/svg/Icons/32/notes-gray-3d98c6.svg";